
import { SalaryStructure } from '@/types';

// Mock Salary Structures
export const salaryStructures: SalaryStructure[] = [
  {
    id: 'sal-1',
    employeeId: 'emp-1',
    basicSalary: 5000,
    allowances: [
      { id: 'all-1', name: 'Housing', amount: 1000, type: 'fixed' },
      { id: 'all-2', name: 'Transport', amount: 500, type: 'fixed' }
    ],
    deductions: [
      { id: 'ded-1', name: 'Tax (PAYE)', amount: 15, type: 'percentage' },
      { id: 'ded-2', name: 'Pension (NAPSA)', amount: 5, type: 'percentage' }
    ]
  },
  {
    id: 'sal-2',
    employeeId: 'emp-2',
    basicSalary: 4000,
    allowances: [
      { id: 'all-3', name: 'Housing', amount: 800, type: 'fixed' },
      { id: 'all-4', name: 'Transport', amount: 400, type: 'fixed' }
    ],
    deductions: [
      { id: 'ded-3', name: 'Tax (PAYE)', amount: 15, type: 'percentage' },
      { id: 'ded-4', name: 'Pension (NAPSA)', amount: 5, type: 'percentage' }
    ]
  },
  {
    id: 'sal-3',
    employeeId: 'emp-3',
    basicSalary: 3500,
    allowances: [
      { id: 'all-5', name: 'Housing', amount: 700, type: 'fixed' },
      { id: 'all-6', name: 'Transport', amount: 350, type: 'fixed' }
    ],
    deductions: [
      { id: 'ded-5', name: 'Tax (PAYE)', amount: 15, type: 'percentage' },
      { id: 'ded-6', name: 'Pension (NAPSA)', amount: 5, type: 'percentage' }
    ]
  },
  {
    id: 'sal-4',
    employeeId: 'emp-4',
    basicSalary: 3800,
    allowances: [
      { id: 'all-7', name: 'Housing', amount: 760, type: 'fixed' },
      { id: 'all-8', name: 'Transport', amount: 380, type: 'fixed' }
    ],
    deductions: [
      { id: 'ded-7', name: 'Tax (PAYE)', amount: 15, type: 'percentage' },
      { id: 'ded-8', name: 'Pension (NAPSA)', amount: 5, type: 'percentage' }
    ]
  },
  {
    id: 'sal-5',
    employeeId: 'emp-5',
    basicSalary: 4200,
    allowances: [
      { id: 'all-9', name: 'Housing', amount: 840, type: 'fixed' },
      { id: 'all-10', name: 'Transport', amount: 420, type: 'fixed' }
    ],
    deductions: [
      { id: 'ded-9', name: 'Tax (PAYE)', amount: 15, type: 'percentage' },
      { id: 'ded-10', name: 'Pension (NAPSA)', amount: 5, type: 'percentage' }
    ]
  }
];
